(() => {
  const focusStatus = (scope = document) => {
    const roots = scope.matches?.('[data-bt-vies-request]')
      ? [scope]
      : scope.querySelectorAll('[data-bt-vies-request]');

    roots.forEach((root) => {
      const status = root.querySelector('[data-bt-vies-status]');
      if (!status || status.dataset.btViesFocused === 'true') return;
      status.dataset.btViesFocused = 'true';
      status.focus({ preventScroll: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => focusStatus(), { once: true });
  } else {
    focusStatus();
  }

  document.addEventListener('shopify:section:load', (event) => focusStatus(event.target));
})();
